import React from "react";
import "./Details.scss";

function Details(props) {
  const { author, date, time, margin, onLanding } = props;
  return (
    <div className={`details-${margin}`}>
      <div className="details-container">
        <p className="details-container-text">Por: {author}</p>
      </div>
      <div className="details-container">
        <p className="details-container-text">Publicado: {date}</p>
      </div>
      {!onLanding && <div className="details-container">
        <p className="details-container-text">Lectura: {time} minutos</p>
      </div>}
    </div>
  );
}

export default Details;
